/* eslint-disable react/prop-types */
import styled from 'styled-components'

const Button = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;

  & > span {
    ${({ type }: { type: string }) =>
      type === 'group-pages-item' &&
      `
      max-width: 125px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: ${({ color }: { color: string }) =>
        color ? `var(${color})` : '#616161'}; /* character/secondary */
  `}
  }
`

export default Button
